// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"109fb49f","453":"89a7b6e5"}[chunkId] + ".chunk.js";
};